import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import { get_stock_ledger } from "../../../Controllers/Dashboard/Dashboard";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";

const StockLedger = () => {
    let location = useLocation();
    let componentRef = useRef();

    const [loader, setLoader] = useState(false);
    const [movements, setMovements] = useState([]);
    const [summary, setSummary] = useState([]);
    const [role, setRole] = useState("");


    const headers = {
        name: "Stock Ledger Report",
        components: [
            {
                type: "search",
                name: "search",
                placeholder: "Search by product/document",
                value: "",
            },
            {
                type: "select",
                name: "sort",
                placeholder: "Sort",
                allowClear: true,
                showSearch: false,
                filterOption: true,
                value: null,
                options: [
                    { value: 0, label: "Total (Low-High)" },
                    { value: 1, label: "Total (High-Low)" },
                    { value: 2, label: "Date (Newest)" },
                    { value: 3, label: "Date (Oldest)" },
                ],
            },
            {
                type: "filter",
                name: "product",
                allowClear: true,
                showSearch: true,
                filterOption: true,
                placeholder: "Product",
                api: "get-all-products",
                value: null,
                options: null,
                valueField: "_id",
                labelField: "name"
            },
            {
                type: "filter",
                name: "branch",
                allowClear: true,
                showSearch: true,
                filterOption: false,
                placeholder: "Branch",
                api: "get-all-branches",
                value: null,
                options: null,
            },
            {
                type: "filter",
                name: "type",
                placeholder: "Transaction Type",
                value: null,
                allowClear: true,
                showSearch: false,
                filterOption: true,
                options: [
                    { value: "PRODUCT_CREATE", label: "Product Creation" },
                    { value: "STOCK_IN", label: "Stock In" },
                    { value: "STOCK_OUT", label: "Stock Out" },
                    { value: "PURCHASE_CREATE", label: "Purchase Order" },
                    { value: "TRANSFER_OUT", label: "Transfer Out" },
                    { value: "TRANSFER_IN", label: "Transfer In" },
                    { value: "RETURN_OUT", label: "Purchase Return" }
                ],
            },
            {
                type: "range",
                name: "date",
                value: {
                    start: "",
                    end: "",
                },
            },
        ],
        navigate: {
            tabs: [
                {
                    name: "Reports",
                    path: "/app/reports",
                },
                {
                    name: "Stock Ledger",
                    path: ""
                }
            ],
            total: [
                { value: 0, label: "Total Items" },
                { value: 0, label: "Stock In" },
                { value: 0, label: "Stock Out" },
            ],
        },
    };



    const [header, setHeader] = useState(headers);

    const formdata = (data) => {
        fetchData(data);
    };

    const fetchData = async (filterData) => {
        try {
            setLoader(true);

            const data = {
                search: filterData?.search,
                sort: filterData?.sort,
                product: filterData?.product,
                branch: filterData?.branch,
                type: filterData?.type,
                date: filterData?.date,
            };

            const result = await get_stock_ledger(data);

            if (result?.status) {
                setMovements(result?.data?.movements || []);
                setSummary(result?.data?.summary || []);
                setRole(result?.data?.role);

                // Update header totals
                const updatedHeader = { ...header };
                updatedHeader.navigate.total[0].value = result?.data?.movements?.length || 0;
                updatedHeader.navigate.total[1].value = result?.data?.summary?.reduce((acc, item) => acc + item.totalIn, 0) || 0;
                updatedHeader.navigate.total[2].value = result?.data?.summary?.reduce((acc, item) => acc + item.totalOut, 0) || 0;
                setHeader(updatedHeader);

                setLoader(false);
            } else {
                toast?.error(result?.message);
                setLoader(false);
            }
        } catch (errors) {
            toast?.error(errors?.message);
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (!role) return;

        let updatedHeader = { ...headers };

        if (role !== "SUPERADMIN") {
            updatedHeader.components = updatedHeader.components.filter(
                (item) => item.name !== "branch"
            );
        }

        setHeader(updatedHeader);
    }, [role]);

    const downloadCSV = () => {
        try {
            if (!movements || movements.length === 0) {
                toast.error("No data available to download");
                return;
            }

            const mainHeaders = [
                "Date",
                "Document No",
                "Type",
                "Product",
                "Unit",
                "Quantity",
                "Rate",
                "Total",
                "Balance",
                "Branch",
                "User",
                "Remarks"
            ];

            let csvContent = [mainHeaders.join(",")];

            movements.forEach((movement) => {
                const row = [
                    new Date(movement.date).toLocaleDateString(),
                    `"${movement.documentNo}"`,
                    movement.type,
                    `"${movement.productName}"`,
                    `"${movement.unit}"`,
                    movement.quantity?.toFixed(3) || "0.000",
                    movement.rate?.toFixed(3) || "0.000",
                    movement.total?.toFixed(3) || "0.000",
                    movement.balance?.toFixed(3) || "0.000",
                    `"${movement.branch}"`,
                    `"${movement.userName}"`,
                    `"${movement.remarks}"`
                ];
                csvContent.push(row.join(","));
            });

            csvContent.push("");
            csvContent.push(["", "", "", "", "", "SUMMARY", "", "", "", "", "", ""].join(","));
            csvContent.push(["Product", "Unit", "Total In", "Total Out", "Current Stock", "Total Value"].join(","));

            summary.forEach((item) => {
                const summaryRow = [
                    `"${item.productName}"`,
                    `"${item.unit}"`,
                    item.totalIn?.toFixed(3) || "0.000",
                    item.totalOut?.toFixed(3) || "0.000",
                    item.currentStock?.toFixed(3) || "0.000",
                    item.totalValue?.toFixed(3) || "0.000"
                ];
                csvContent.push(summaryRow.join(","));
            });

            const encoder = new TextEncoder();
            const encodedContent = encoder.encode('\uFEFF' + csvContent);

            const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);

            link.setAttribute("href", url);
            link.setAttribute("download", `Stock_Ledger_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
            link.style.visibility = 'hidden';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error generating CSV:", error);
            toast.error("Failed to generate CSV file");
        }
    };

    const downloadPDF = () => {
        try {
            if (!movements || movements.length === 0) {
                toast.error("No data available to download");
                return;
            }

            const doc = new jsPDF({
                orientation: "landscape",
                unit: "mm",
                format: "a4",
            });

            registerCairoFont(doc);
            const pageWidth = doc.internal.pageSize.getWidth();

            let startY = 20;

            // Title
            doc.setFont("Cairo-Bold", "bold");
            doc.setFontSize(16);
            doc.text("Stock Ledger Report", pageWidth / 2, startY, { align: "center" });

            doc.setFontSize(10);
            doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, startY + 10);
            doc.text(`Total Records: ${movements.length}`, pageWidth - 30, startY + 10);

            startY += 25;

            // Movements Table
            const movementHeaders = [
                ["Date", "Doc No", "Type", "Product", "Unit", "Qty", "Rate", "Total", "Balance", "Remarks"]
            ];

            const movementData = movements.map(movement => [
                new Date(movement.date).toLocaleDateString(),
                movement.documentNo,
                movement.type,
                movement.productName,
                movement.unit,
                movement.quantity?.toFixed(3) || "0.000",
                movement.rate?.toFixed(3) || "0.000",
                movement.total?.toFixed(3) || "0.000",
                movement.balance?.toFixed(3) || "0.000",
                movement.remarks
            ]);

            autoTable(doc, {
                startY: startY,
                head: movementHeaders,
                body: movementData,
                theme: 'grid',
                styles: {
                    font: "Cairo",
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    lineColor: [7, 181, 83],
                    lineWidth: 0.2,
                    cellPadding: 1.5
                },
                headStyles: {
                    font: "Cairo",
                    fontStyle: "bold",
                    fillColor: false,
                    lineColor: [7, 181, 83],
                    lineWidth: 0.6
                },
                margin: { left: 14 }
            });

            startY = doc.lastAutoTable.finalY + 15;

            // Summary Table
            if (summary.length > 0) {
                doc.setFontSize(12);
                doc.text("Product Summary", 14, startY);
                startY += 8;

                const summaryHeaders = [["Product", "Unit", "Total In", "Total Out", "Current Stock", "Total Value"]];
                const summaryData = summary.map(item => [
                    item.productName,
                    item.unit,
                    item.totalIn?.toFixed(3) || "0.000",
                    item.totalOut?.toFixed(3) || "0.000",
                    item.currentStock?.toFixed(3) || "0.000",
                    item.totalValue?.toFixed(3) || "0.000"
                ]);

                autoTable(doc, {
                    startY: startY,
                    head: summaryHeaders,
                    body: summaryData,
                    theme: 'grid',
                    styles: {
                        font: "Cairo",
                        fontSize: 8,
                        textColor: [0, 0, 0],
                        lineColor: [7, 181, 83],
                        lineWidth: 0.2,
                        cellPadding: 1.5
                    },
                    headStyles: {
                        font: "Cairo",
                        fontStyle: "bold",
                        fillColor: false,
                        lineColor: [7, 181, 83],
                        lineWidth: 0.6
                    },
                    margin: { left: 14 }
                });
            }

            const formattedDate = new Date().toLocaleDateString("en-GB");
            doc.save(`Stock_Ledger_${formattedDate}.pdf`);

        } catch (error) {
            console.error("Error generating PDF:", error);
            toast.error("Failed to generate PDF file");
        }
    };

    const getTypeColor = (type) => {
        const inTypes = ['STOCK_IN', 'TRANSFER_IN', 'PURCHASE_CREATE'];
        const outTypes = ['STOCK_OUT', 'TRANSFER_OUT', 'RETURN_OUT'];

        if (inTypes.includes(type)) {
            return 'text-green-600';
        } else if (outTypes.includes(type)) {
            return 'text-red-600';
        } else if (type === 'PRODUCT_CREATE') {
            return 'text-blue-600';
        }
        return 'text-gray-600';
    };

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <div className="mt-4">
                    <div className="text-right flex gap-3 justify-end">
                        <Button
                            className="text-medium form-save-button"
                            type="primary"
                            onClick={downloadCSV}
                        >
                            Download CSV
                        </Button>

                        <Button
                            className="text-medium form-save-button"
                            type="primary"
                            onClick={downloadPDF}
                        >
                            Download PDF
                        </Button>
                    </div>
                </div>

                <ScrollWrapper>
                    <div
                        className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
                        ref={(el) => (componentRef = el)}
                    >
                        {/* Summary Section */}
                        {summary.length > 0 && (
                            <div className="mb-6">
                                <h3 className="text-lg font-semibold mb-3">Product Summary</h3>
                                <table className="w-full bg-white border-collapse mb-4">
                                    <thead className="text-gray-500 bg-gray-100">
                                        <tr>
                                            <th className="border p-2 text-sm font-normal">Product</th>
                                            <th className="border p-2 text-sm font-normal">Unit</th>
                                            <th className="border p-2 text-sm font-normal">Total In</th>
                                            <th className="border p-2 text-sm font-normal">Total Out</th>
                                            <th className="border p-2 text-sm font-normal">Current Stock</th>
                                            <th className="border p-2 text-sm font-normal">Total Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {summary.map((item, index) => (
                                            <tr key={index} className="hover:bg-gray-50">
                                                <td className="border p-2 text-sm">{item.productName}</td>
                                                <td className="border p-2 text-sm text-center">{item.unit}</td>
                                                <td className="border p-2 text-sm text-center text-green-600">
                                                    {item.totalIn?.toFixed(3)}
                                                </td>
                                                <td className="border p-2 text-sm text-center text-red-600">
                                                    {item.totalOut?.toFixed(3)}
                                                </td>
                                                <td className={`border p-2 text-sm text-center font-semibold ${item.currentStock > 0 ? 'text-green-600' :
                                                    item.currentStock < 0 ? 'text-red-600' : 'text-gray-600'
                                                    }`}>
                                                    {item.currentStock?.toFixed(3)}
                                                </td>
                                                <td className="border p-2 text-sm text-center">
                                                    {item.totalValue?.toFixed(3)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Movements Table */}
                        <h3 className="text-lg font-semibold mb-3">Stock Movements</h3>
                        <table className="w-full bg-white border-collapse">
                            <thead className="text-gray-500 bg-gray-100 sticky top-0 z-10">
                                <tr>
                                    <th className="border p-2 text-sm font-normal">Date</th>
                                    <th className="border p-2 text-sm font-normal">Document No</th>
                                    <th className="border p-2 text-sm font-normal">Type</th>
                                    <th className="border p-2 text-sm font-normal">Product</th>
                                    <th className="border p-2 text-sm font-normal">Unit</th>
                                    <th className="border p-2 text-sm font-normal">Quantity</th>
                                    <th className="border p-2 text-sm font-normal">Rate</th>
                                    <th className="border p-2 text-sm font-normal">Total</th>
                                    <th className="border p-2 text-sm font-normal">Balance</th>
                                    <th className="border p-2 text-sm font-normal">Branch</th>
                                    <th className="border p-2 text-sm font-normal">User</th>
                                    <th className="border p-2 text-sm font-normal">Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {movements.map((movement, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="border p-2 text-sm">
                                            {new Date(movement.date).toLocaleDateString()}
                                        </td>
                                        <td className="border p-2 text-sm font-medium">
                                            {movement.documentNo}
                                        </td>
                                        <td className={`border p-2 text-sm font-semibold ${getTypeColor(movement.type)}`}>
                                            {movement.type}
                                        </td>
                                        <td className="border p-2 text-sm">{movement.productName}</td>
                                        <td className="border p-2 text-sm text-center">{movement.unit}</td>
                                        <td className={`border p-2 text-sm text-center ${movement.type.includes('IN') ? 'text-green-600' : 'text-red-600'
                                            }`}>
                                            {movement.quantity?.toFixed(3)}
                                        </td>
                                        <td className="border p-2 text-sm text-center">
                                            {movement.rate?.toFixed(3)}
                                        </td>
                                        <td className="border p-2 text-sm text-center">
                                            {movement.total?.toFixed(3)}
                                        </td>
                                        <td className={`border p-2 text-sm text-center font-semibold ${movement.balance > 0 ? 'text-green-600' :
                                            movement.balance < 0 ? 'text-red-600' : 'text-gray-600'
                                            }`}>
                                            {movement.balance?.toFixed(3)}
                                        </td>
                                        <td className="border p-2 text-sm text-center">
                                            {movement.branch?.name || ''}
                                        </td>
                                        <td className="border p-2 text-sm text-center">
                                            {movement.userName}
                                        </td>
                                        <td className="border p-2 text-sm">{movement.remarks}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className="sticky bottom-0 bg-white z-10">
                                <tr className="font-semibold bg-gray-100 text-sm">
                                    <td className="border p-2 font-normal" colSpan={5}>
                                        Grand Totals
                                    </td>
                                    <td className="border p-2 font-normal text-center">
                                        {movements.reduce((acc, m) => acc + m.quantity, 0)?.toFixed(3)}
                                    </td>
                                    <td className="border p-2 font-normal text-center">
                                        {movements.reduce((acc, m) => acc + (m.rate || 0), 0)?.toFixed(3)}
                                    </td>
                                    <td className="border p-2 font-normal text-center">
                                        {movements.reduce((acc, m) => acc + m.total, 0)?.toFixed(3)}
                                    </td>
                                    <td className={`border p-2 font-normal text-center ${movements[movements.length - 1]?.balance > 0 ? 'text-green-600' :
                                        movements[movements.length - 1]?.balance < 0 ? 'text-red-600' : 'text-gray-600'
                                        }`}>
                                        {movements[movements.length - 1]?.balance?.toFixed(3) || "0.000"}
                                    </td>
                                    <td className="border p-2 font-normal text-center" colSpan={3}></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </ScrollWrapper>
            </Loadercomponent>
        </Header>
    );
};

export default StockLedger;